import StrainEffectTiles from "./StrainEffectTiles";

export default StrainEffectTiles;
